import ContainerizedApps from '../images/containerized-apps-simplified.png';
import EventDrivenApps from '../images/event-driven-apps-simplified.png';

export interface Project {
  id: number;
  title: string;
  description: string;
  tags: string[];
  image: string;
  urlSuffix: string;
}

export interface Props {
  searchTerm: string;
  filter: string;
}

export const CardsData: Project[] = [
  {
    id: 1,
    title: 'RA-1: Containerized Applications',
    description:
      'This architectural pattern aims to offer a standardized solution for running containerized applications',
    image: ContainerizedApps,
    tags: [
      'containers',
      'architecture',
      'services',
      'pattern',
      'ECS',
      'fargate',
      'docker',
    ],
    urlSuffix:
      'architecture-center/reference-architectures/ra-1-containerized-applications/',
  },
  {
    id: 2,
    title: 'RA-2: Event-driven Architectures with Events Platform',
    description:
      'This reference architecture outlines best practices for building event-driven architectures within the company technology solutions using our Events Platform based on Confluent Kafka.',
    image: EventDrivenApps,
    tags: [
      'event-driven',
      'architecture',
      'kafka',
      'pattern',
      'events-platform',
    ],
    urlSuffix:
      'architecture-center/reference-architectures/ra-2-event-driven-arch-with-events-platform/',
  },
];
